<template>
  <div v-if="isVisible" class="fixed inset-0 z-[100] flex items-center justify-center p-4 bg-black/50 backdrop-blur-sm transition-all">
    <div class="bg-white rounded-3xl shadow-2xl w-full max-w-md overflow-hidden transform transition-all animate-in fade-in zoom-in duration-300">
      <div class="p-8">
        <h3 class="text-2xl font-black text-gray-900 mb-2 truncate">{{ title }}</h3>
        <p class="text-gray-500 text-sm mb-6 leading-relaxed">{{ subtitle }}</p>
        
        <div v-if="mode === 'input'" class="mb-6">
          <label class="block text-xs font-bold text-gray-400 uppercase tracking-wider mb-2">Message</label>
          <textarea
            v-model="inputValue"
            :placeholder="placeholder"
            class="w-full h-32 p-4 bg-gray-50 border border-gray-100 rounded-2xl focus:bg-white focus:border-primary-500 focus:ring-4 focus:ring-primary-500/10 outline-none transition-all resize-none text-sm placeholder:text-gray-300"
          ></textarea>
        </div>

        <div class="flex items-center gap-3">
          <button
            @click="$emit('cancel')"
            class="flex-1 px-6 py-3.5 text-sm font-bold text-gray-500 bg-gray-100 rounded-2xl hover:bg-gray-200 transition-all active:scale-95"
          >
            Annuler
          </button>
          <button
            @click="handleConfirm"
            :disabled="mode === 'input' && !inputValue.trim()"
            class="bg-primary flex-1 px-6 py-3.5 text-sm font-bold text-white shadow-lg shadow-primary-500/20 rounded-2xl transition-all active:scale-95 disabled:opacity-50 disabled:grayscale disabled:pointer-events-none"
            :class="confirmButtonClass"
          >
            {{ confirmText }}
          </button>
        </div>
      </div>
    </div>
  </div>
</template>

<script setup>
import { ref, computed, watch } from 'vue'

const props = defineProps({
  isVisible: Boolean,
  title: String,
  subtitle: String,
  mode: {
    type: String,
    default: 'confirm' // 'confirm' or 'input'
  },
  placeholder: {
    type: String,
    default: 'Saisissez votre message ici...'
  },
  confirmText: {
    type: String,
    default: 'Confirmer'
  },
  confirmType: {
    type: String,
    default: 'primary' // 'primary', 'danger', 'success'
  }
})

const emit = defineEmits(['confirm', 'cancel'])

const inputValue = ref('')

const confirmButtonClass = computed(() => {
  switch (props.confirmType) {
    case 'danger': return 'bg-red-600 hover:bg-red-700'
    case 'success': return 'bg-success-600 hover:bg-success-700'
    default: return 'bg-primary-600 hover:bg-primary-700'
  }
})

const handleConfirm = () => {
  if (props.mode === 'input') {
    emit('confirm', inputValue.value)
  } else {
    emit('confirm')
  }
}

// Reset input when shown
watch(() => props.isVisible, (newVal) => {
  if (newVal) inputValue.value = ''
})
</script>
